import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-count",
  "use": "icon-count-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-count\">\n<g>\n\t<path d=\"M15.1,29.2c-1.9,0-3.5,1.6-3.5,3.5v134.4c0,1.9,1.6,3.5,3.5,3.5h169.8c1.9,0,3.5-1.6,3.5-3.5V32.7c0-1.9-1.6-3.5-3.5-3.5\n\t\tH15.1z M15.1,18.6h169.8c7.8,0,14.2,6.3,14.2,14.2v134.4c0,7.8-6.3,14.2-14.2,14.2H15.1c-7.8,0-14.2-6.3-14.2-14.2V32.7\n\t\tC0.9,24.9,7.3,18.6,15.1,18.6z\" />\n\t<g>\n\t\t<path d=\"M65.9,57.5h24.8l26.1,52.6V57.5H134v84.8h-19.9L83.2,80.9v61.4H65.9V57.5z\" />\n\t</g>\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol